import { getBaseUrl, getGlobalParams, parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const msgApi = baseApi.injectEndpoints({
  tagTypes: ['MessagesList'],
  endpoints: (builder) => ({
    getMessages: builder.query({
      query: (params) => {
        return {
          url: `/care_stream.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {return parseResponse(response);},
      providesTags: ['MessagesList'],
    }),
    sendMessage: builder.mutation({
      query: (body) => {
        return {
          url: `/messages/create.json`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ['MessagesList']
    }),
    uploadAttachment: builder.mutation({
      query: (body) => {
        return {
          url: `/messages/attachment.json`,
          method: "POST",
          body: body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetMessagesQuery, useSendMessageMutation } = msgApi;

export const postAttachment = (file, file_type, callbacks) => {
  console.log('file to upload----', file_type,file);
  const resourceUrl = '/messages/attachment.json',
  url = getBaseUrl()+ resourceUrl + "?" + getGlobalParams();
  let formData = new FormData(),
  xhr = new XMLHttpRequest(),
  progress = 0;

  formData.append('file', file);
  formData.append('file_type', file_type);

  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        if(callbacks?.onStateChange){
          callbacks?.onStateChange(JSON.parse(xhr.response));
        }
      } else {
        if(callbacks?.onError){
          callbacks?.onError(xhr.response);
        }
      }
    }
  };

  xhr.upload.onprogress = (event) => {
    progress = Math.round(event.loaded / event.total * 100);
    if(callbacks?.onProgress){
      callbacks?.onProgress({
        value: progress,
        abortRequest: function(){
            xhr.abort();
        }
      });
    }
  };
  xhr.open('POST', url, true);
  xhr.send(formData);
}
